module.exports = __webpack_public_path__ + "static/CV-63e8abf226953a7a9652bee3e1b8a0cb.pdf";